/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  PlanService,
  Wealthlane_AwardService_Dtos_Response_ResponseDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const usePostPlanGrantDocumentDetailByPlanGrantDocumentId = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string,
  setResetFiles?: (value: boolean) => void
): UseMutationResult<
  Wealthlane_AwardService_Dtos_Response_ResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: any) => {
      if (id) {
        return await handleRequest(
          PlanService.postApiAwardApiAppPlanPlanGrantDocumentDetail(id, payload)
        );
      }
    },
    {
      onSuccess: async (response) => {
        if (response != null) {
          toast.success(
            <ToastComponent label='Success' message={`Plan Grant Document Detail Added`} />
          );
          setResetFiles(true);
          await queryClient.invalidateQueries('getPlanGrantDocumentDetailById');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostPlanGrantDocumentDetailByPlanGrantDocumentId;
